module.exports = __webpack_public_path__ + "3626f67019bdd4c16c5a370b0532a355.png";